<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class="data-grid">
      <dx-data-grid ref='refLineStatus'
        :data-source='machineFaultInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        :focused-row-key.sync='focusedRowKey'
        key-expr="설비코드"
        @cell-prepared='onCellPrepared'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="exportTitle"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="라인명"
          data-field="라인명"
          :visible='true'
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="설비명"
          data-field="설비명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="설비코드"
          data-field="설비코드"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="고장건수"
          data-field="count"
          format="#,##0"
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="평균수리시간(MTTR)"
          data-field="mttr"
          :calculate-cell-value="getMttr"
          format="#,##0.0"
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="평균가동시간(MTTF)"
          data-field="mttf"
          :calculate-cell-value="getMttf"
          format="#,##0.0"
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="평균고장시간간격(MTBF)"
          data-field="mtbf"
          :calculate-cell-value="getMtbf"
          format="#,##0.0"
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="설비신뢰도(MTBF/(MTBF+MTTR))"
          :calculate-cell-value="getAvailability"
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="설비고장율(MTTR/(MTBF+MTTR))"
          :calculate-cell-value="getFaultRate"
          dataType="number"
        >
        </DxColumn>
        <DxSummary :calculate-custom-summary="calculateCustomSummary">
          <DxTotalItem
            value-format='#,##0'
            column="라인명"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0'
            column="count"
            summary-type="sum"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0.0'
            column="mttr"
            name="mttr"
            summary-type="custom"
            display-format="{0} Hr"
          />
          <DxTotalItem
            value-format='#,##0.0'
            column="mttf"
            name="mttf"
            summary-type="custom"
            display-format="{0} 일"
          />
          <DxTotalItem
            value-format='#,##0.0'
            column="mtbf"
            name="mtbf"
            summary-type="custom"
            display-format="{0} 일"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
      <ul class='chart-wrap'>
        <li class='float-left'>
          <div class="title toolbar-label" style='position:absolute;top:10px;left:10px;color:rgb(4, 103, 189);'>고장유형별 점유율</div>
          <DxPieChart
            class='fail-group-chart'
            :data-source="failGroupSource"
            palette="Office"
            size-group="piesGroup2"
            type="doughnut"
            :inner-radius="0.6"
          >
            <DxSeries
              argument-field="type"
              value-field="time"
            >
              <DxLabel
                :visible="true"
                :customize-text="formatLabel"
                position="columns"
              >
                <DxConnector
                  :visible="true"
                  :width="1"
                />
              </DxLabel>
              <DxSmallValuesGrouping
                :threshold="1.0"
                mode="smallValueThreshold"
              />
            </DxSeries>
            <DxSize :width="pieChartWidth" :height="300"/>
            <DxLegend
              :margin="0"
              horizontal-alignment="right"
              vertical-alignment="top"
            />
            <DxTooltip
              :enabled="true"
              :customize-tooltip="customizeTooltipPie"
            >
              <DxFormat
              />
            </DxTooltip>
          </DxPieChart>
        </li>
        <li class='float-left'>
          <div class="title toolbar-label" style='position:absolute;top:10px;left:10px;color:rgb(4, 103, 189);'>고장부위별 점유율</div>
          <DxPieChart
            class='fail-device-chart'
            :data-source="failDeviceSource"
            palette="Office"
            size-group="piesGroup2"
            type="doughnut"
            :inner-radius="0.6"
          >
            <DxSeries
              argument-field="type"
              value-field="time"
            >
              <DxLabel
                :visible="true"
                :customize-text="formatLabel"
                position="columns"
              >
                <DxConnector
                  :visible="true"
                  :width="1"
                />
              </DxLabel>
              <DxSmallValuesGrouping
                :threshold="1.0"
                mode="smallValueThreshold"
              />
            </DxSeries>
             <DxSize :width="pieChartWidth" :height="300"/>
            <DxLegend
              :margin="0"
              horizontal-alignment="right"
              vertical-alignment="top"
            />
            <DxTooltip
              :enabled="true"
              :customize-tooltip="customizeTooltipPie"
            >
              <DxFormat
              />
            </DxTooltip>
          </DxPieChart>
        </li>
      </ul>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
// import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxSummary,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'
import axios from 'axios'
import DxPieChart, { DxConnector, DxFormat, DxSmallValuesGrouping, DxSeries, DxLegend, DxLabel, DxTooltip, DxSize } from 'devextreme-vue/pie-chart'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      machineFaultInfoList: null,
      exportTitle: '설비수리통계',
      faultDefineLookup: null,
      faultTypeLookup: null,
      focusedRowKey: null,
      failDeviceSource: null,
      failGroupSource: null,
      pieChartWidth: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxConnector,
    DxFormat,
    DxSmallValuesGrouping,
    DxPieChart,
    DxSeries,
    DxLegend,
    DxLabel,
    DxTooltip,
    DxSize
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.faultDefineLookup = this.$store.getters.getBaseDataByType(ConstDef.고장계통)
    this.faultTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.고장유형)
    this.refreshFaultList()
    this.refreshStatistics()
  },
  mounted () {
    this.gridHeight = (screen.height - 680) * 0.95
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  updated () {
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    calculateCustomSummary (options) {
      if (options.name === 'mttr') {
        switch (options.summaryProcess) {
          case 'start':
            options.totalValue = 0
            break
          case 'finalize':
            for (let i = 0; i < this.machineFaultInfoList.length; i++) {
              options.totalValue += this.machineFaultInfoList[i].mttr
            }
            options.totalValue = (options.totalValue / 60 / this.machineFaultInfoList.length).toFixed(1)
            break
        }
      } else if (options.name === 'mttf') {
        switch (options.summaryProcess) {
          case 'start':
            options.totalValue = 0
            break
          case 'finalize':
            for (let i = 0; i < this.machineFaultInfoList.length; i++) {
              options.totalValue += this.machineFaultInfoList[i].mttf
            }
            options.totalValue = (options.totalValue / 60 / 24 / this.machineFaultInfoList.length).toFixed(1)
            break
        }
      } else {
        switch (options.summaryProcess) {
          case 'start':
            options.totalValue = 0
            break
          case 'finalize':
            for (let i = 0; i < this.machineFaultInfoList.length; i++) {
              options.totalValue += this.machineFaultInfoList[i].mtbf
            }
            options.totalValue = (options.totalValue / 60 / 24 / this.machineFaultInfoList.length).toFixed(1)
            break
        }
      }
    },
    getMttr (row) {
      return (row.mttr / 60).toFixed(1) + 'Hr'
    },
    getMttf (row) {
      return (row.mttf / 60 / 24).toFixed(1) + '일'
    },
    getMtbf (row) {
      return (row.mtbf / 60 / 24).toFixed(1) + '일'
    },
    getAvailability (row) {
      return (row.mtbf / (row.mtbf + row.mttr) * 100).toFixed(1) + '%'
    },
    getFaultRate (row) {
      return (row.mttr / (row.mtbf + row.mttr) * 100).toFixed(1) + '%'
    },
    handleResize () {
      console.log(this.$Q('.chart-wrap li').width())
      this.pieChartWidth = this.$Q('.chart-wrap li').width() - 20
    },
    onCellPrepared  (e) {

    },
    refreshFaultList () {
      const status = this.$_sp.runNoEncodeFindProc('spFindAllMachineRepairStatistics', {})
      axios.all([status])
        .then(axios.spread((...reponse) => {
          this.machineFaultInfoList = this.$_sp.MakeModel(reponse[0])
          console.log(this.machineFaultInfoList)
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // chart
    customizeTooltipPie (e) {
      console.log(e)
      return { text: `${e.argumentText}: ${e.valueText}(Hr)`, color: 'rgb(116, 255, 255)' }
    },
    formatLabel (pointInfo) {
      return `${pointInfo.percentText}`
    },
    refreshStatistics () {
      const group = this.$_sp.runNoEncodeFindProc('spFindAllRepairTimeGbyFailGroup', {})
      const device = this.$_sp.runNoEncodeFindProc('spFindAllRepairTimeGbyFailDevice', {})

      axios.all([group, device])
        .then(axios.spread((...response) => {
          this.failGroupSource = this.$_sp.MakeModel(response[0])
          this.failDeviceSource = this.$_sp.MakeModel(response[1])
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.chart-wrap {
  margin-top: 10px;
  border: 0px solid red;
  height: 400px;
  .title {
    font-size: 1.3rem;
    font-weight: bold;
  }
  li {
    width:49%;
    height: 400px;
    border: 1px solid rgb(168, 168, 168);
    border-radius: 10px;
    padding-top:50px;
    position: relative;
  }
  li:first-child {
    margin-right: 2%;
  }
}
</style>
